module.exports = "/_next/static/images/img__clock-eae86d6307d91767cebad943154e9fd1.png";